import React from "react";
import "./products.css";

function Product({ imagem, id }) {
  return (
    <div className="p">
      <div className="p-browser">
        <div className="p-circle1"></div>
        <div className="p-circle2"></div>
        <div className="p-circle3"></div>
      </div>
      { id !== 6 
        ? <img src={imagem} alt="imagem" className="p-img" />
        : <img src={imagem} alt="imagem" className="p-img2" />
      }
    </div>
  );
}

export default Product;
